import { Error, Paging } from "api/baseApiResponseModel/BaseApiResponseModel";
import { ApiDocumentRequestModel } from "api/merchantRepository/supportFeature/model/apiDocument/ApiDocumentRequestModel";
import { ApiDocumentResponseModel } from "api/merchantRepository/supportFeature/model/apiDocument/ApiDocumentResponseModel";
import { BaseViewModel } from "components/base/BaseViewModel";
import { BehaviorSubject } from "rxjs";
import { injectable } from "tsyringe";
import { ServiceRepo } from "utils/serviceRepo/ServiceRepo";

class ApiDocumentInput implements Disposable {
  public fetchDoc = new BehaviorSubject<ApiDocumentRequestModel>(
    new ApiDocumentRequestModel()
  );
  public fetchDispatch = new BehaviorSubject<ApiDocumentRequestModel>(
    new ApiDocumentRequestModel()
  );
  public loading = new BehaviorSubject<boolean>(false);

  [Symbol.dispose](): void {
    this.fetchDoc.complete();
    this.fetchDispatch.complete();
    this.loading.complete();
  }
}

class ApiDocumentOutput implements Disposable {
  public savedDoc = new BehaviorSubject<Array<ApiDocumentResponseModel>>([]);
  public savedDispatch = new BehaviorSubject<Array<ApiDocumentResponseModel>>(
    []
  );
  public savedPaging = new BehaviorSubject<Paging>({});
  public onError = new BehaviorSubject<Error>({});

  [Symbol.dispose](): void {
    this.savedDoc.complete();
    this.savedDispatch.complete();
    this.savedPaging.complete();
    this.onError.complete();
  }
}

@injectable()
export class ApiDocumentViewModel extends BaseViewModel<
  ApiDocumentInput,
  ApiDocumentOutput
> {
  constructor() {
    super(new ApiDocumentInput(), new ApiDocumentOutput());
  }
  private repo = ServiceRepo.getSupportFeatureRepo();

  protected override transform(): void {
    this.skipFirstInitial(this.input.fetchDoc, async (params) => {
      try {
        const res = await this.repo.viewDocument(params);
        if (res?.data) {
          this.output.savedDoc.next(res?.data);
        }
      } catch (error) {
        console.error(error);
        this.output.onError.next(error);
      }
    });

    this.skipFirstInitial(this.input.fetchDispatch, async (params) => {
      try {
        const res = await this.repo.viewOfficialDispatch(params);
        if (res?.data) {
          this.output.savedDispatch.next(res?.data);
        }
      } catch (error) {
        console.error(error);
        this.output.onError.next(error);
      }
    });
  }
}
